import { configureStore } from '@reduxjs/toolkit';
import { moduleReducer } from './moduleSlice';

const moduleStore = configureStore({
  reducer: moduleReducer,
  preloadedState: {
    selectedModule: {},
  },
});

export type IModuleState = ReturnType<typeof moduleStore.getState>;

export type IModuleDispatch = typeof moduleStore.dispatch;

export default moduleStore;
